import {formatSlaDuration} from '../../tickets/utils/slaPresentation';

/**
 * How the dashboard's rollups read.
 *
 * The one place a rollup is formatted: the table's totals row and every group
 * header show the same three (of five) figures over different row sets, so they
 * must round once, here, or two numbers over the same tickets end up disagreeing by
 * a percentage point. `groupStatsFormatting` delegates to this module for exactly
 * that reason.
 */

/** An absent rollup — nothing in scope to compute it from. Matches the table's empty-cell dash. */
const NO_VALUE = '—';

/** A 0–1 ratio as a whole percentage. Null reads as a dash, not `0%`. */
export function formatPct(ratio: number | null): string {
	if (ratio == null) return NO_VALUE;
	return `${Math.round(ratio * 100)}%`;
}

export function formatTotalCount(total: number): string {
	return String(total);
}

/** Seconds in the ticketing tree's compact duration form — `2d 3h`, `4h 30m`, `12m`. */
export function formatMedianDuration(seconds: number | null): string {
	if (seconds == null) return NO_VALUE;
	return formatSlaDuration(seconds);
}
